import { render, staticRenderFns } from "./AboutTeraphy.vue?vue&type=template&id=fa84869a"
import script from "./AboutTeraphy.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutTeraphy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports